import ApiClient from '@afosto/api/ApiClient';

class Flows {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create dataflow
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new dataflow
   * @returns {Promise}
   */
  createStream(body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete dataflow
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Delete a single dataflow
   * @returns {Promise}
   */
  deleteDataflow(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get dataflow
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a single dataflow
   * @returns {Promise}
   */
  getDataflow(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List dataflows
   *
   * @param {Object} options - The additional request options
   * @description Get a list of flows
   * @returns {Promise}
   */
  listDataFlows(options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Trigger flow
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Trigger an existing flow
   * @returns {Promise}
   */
  triggerFlow(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows/${id}/trigger`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Update dataflow
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update a single dataflow
   * @returns {Promise}
   */
  updateDataflow(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/dataflow/flows/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const flows = new Flows();

export default Flows;
